import { UPDATE_USER } from './index';
import { UPDATE_ADMIN_STATUS } from './index';
import { UPDATE_USER_DATA } from './index';

export const verifyUser = token => dispatch => {
    if(token) {
        fetch(process.env.REACT_APP_VERIFYUSERSESSION + token).then(result => result.json()).then(json => {
            if(json.success === true) {
                dispatch({
                    type: UPDATE_USER,
                    payload: {
                        userLoading: false,
                        userLoggedIn: true
                    }
                })
            } else {
                localStorage.setItem("token", "");
                dispatch({
                    type: UPDATE_USER,
                    payload: {
                        userLoading: false,
                        userLoggedIn: false
                    }
                })
            }
        })
    } else {
        dispatch({
            type: UPDATE_USER,
            payload: {
                userLoading: false,
                userLoggedIn: false
            }
        })
    }
}

export const verifyAdminStatus = token => dispatch => {
    if (token) {
        fetch(process.env.REACT_APP_VERIFYUSERADMIN + token).then(result => result.json()).then(json => {
            if(json.success === true) {
                dispatch({
                    type: UPDATE_ADMIN_STATUS,
                    payload: {
                        isAdmin: true
                    }
                })
            } else {
                dispatch({
                    type: UPDATE_ADMIN_STATUS,
                    payload: {
                        isAdmin: false
                    }
                })
            }
        })
    } else {
        dispatch({
            type: UPDATE_ADMIN_STATUS,
            payload: {
                isAdmin: false
            }
        })
    }
}

export const userLogOut = token => dispatch => {
    if(token) {
        fetch(process.env.REACT_APP_USERLOGOUT + token).then(response => response.json()).then(json => {
            alert(json.message);
            localStorage.setItem("token", "");
            dispatch({
                type: UPDATE_USER,
                payload: {
                    userLoading: false,
                    userLoggedIn: false
                }
            })
        })
    } else {
        dispatch({
            type: UPDATE_USER,
            payload: {
                userLoading: false,
                userLoggedIn: false
            }
        })
    }
}

export const getUserData = token => dispatch => {
    if (token) {
        fetch(process.env.REACT_APP_GATHERUSERDATA + token).then(result => result.json()).then(json => {
            dispatch({
                type: UPDATE_USER_DATA,
                payload: {
                    userData: json,
                    userDataLoading: false
                }
            })
        })
    } else {
        dispatch({
            type: UPDATE_USER_DATA,
            payload: {
                userData: [],
                userDataLoading: true
            }
        })
    }
}